import { render, staticRenderFns } from "./StudipFiveStarsInput.vue?vue&type=template&id=873e2156&"
import script from "./StudipFiveStarsInput.vue?vue&type=script&lang=js&"
export * from "./StudipFiveStarsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports